export default __webpack_public_path__ + "static/media/ads.3f358db4.png";